import LogoutButton from "components/molecules/LogoutButton";
import Footer from "components/organisms/Footer";
import Header from "components/organisms/Header";
import { getDoc, doc } from "firebase/firestore";
import { db } from "firebaseConfig";
import useLoginUser from "hooks/useLoginUser";
import { useLayoutEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { userConverter } from "types/firestoreTypes";

const DefaultTemplate = ({
    className,
    children,
    style,
    isAdmin = false,
}: {
    className?: string;
    children?: React.ReactNode;
    style?: React.CSSProperties;
    isAdmin?: boolean;
}) => {
    const { user, isLoading } = useLoginUser();
    const [adminCheckLoading, setAdminCheckLoading] = useState(true);
    useLayoutEffect(() => {
        if (!isAdmin || !user) return;
        (async () => {
            const res = await getDoc(
                doc(db, `users/${user.uid}`).withConverter(userConverter)
            );
            if (res.data()?.type !== "moll_admin") {
                window.location.href = "/";
            }
            setAdminCheckLoading(false);
        })();
    }, [user, isAdmin]);

    if (isAdmin && !isLoading && !user) return <Navigate to={"/"} />;

    return (
        <>
            {!isAdmin && <Header />}
            {isAdmin && <LogoutButton />}
            {isAdmin && adminCheckLoading && <h2>Now Loading...</h2>}
            {((isAdmin && !adminCheckLoading) || !isAdmin) && (
                <main className={className} style={style}>
                    {children}
                </main>
            )}
            {!isAdmin && <Footer />}
        </>
    );
};

export default DefaultTemplate;
